import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Placeholder mientras se carga el plan a editar (`GET /my-favorite-plans/:id`).
 * Imita el bloque de cada paso: título, subtítulo y una fila de campos.
 */
const FavoritePlanFormSkeleton = () => (
    <div className="w-100">
        <Skeleton height={32} width="45%" />
        <div className="mt-2">
            <Skeleton height={20} width="70%" />
        </div>

        <div className="row gy-4 mt-4 mx-0">
            {Array.from({ length: 3 }).map((_, index) => (
                <div className="col-12 col-md-4" key={index}>
                    <Skeleton height={16} width="55%" />
                    <div className="mt-2">
                        <Skeleton height={38} />
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default FavoritePlanFormSkeleton;
